import { Grid } from '@orbita-ui/core';
import {
  LoginFooterBottom,
  LoginFooterContainer,
  LoginFooterTop,
} from './LoginFooter.styles';

export const LoginFooter = () => (
  <LoginFooterContainer>
    <LoginFooterTop>
      <Grid>
        <Grid.Item sm={6} xs={4}>
          <p>PRISMA MEDIOS DE PAGO S.A.</p>
        </Grid.Item>
        <Grid.Item sm={6} xs={4}>
          <p>Defensa al Consumidor | Protección de datos personales</p>
        </Grid.Item>
      </Grid>
    </LoginFooterTop>
    <LoginFooterBottom>
      <p>
        Los datos que se proporcionen a Prisma Medios de Pago S.A. podrán utilizarse para
        procesar sus pedidos, solicitudes, denuncias, reclamos, para la relación comercial
        y con fines publicitarios.
      </p>
      <p>
        <strong>Disposición DNPDP 10/2008:</strong>
      </p>
      <p>
        <em>
          "El titular de los datos personales tiene la facultad de ejercer el derecho de
          acceso a los mismos de forma gratuita, a intervalos no inferiores a seis meses,
          salvo que se acredite un interés legítimo al efecto, conforme lo establecido en
          el artículo 14, inciso 3 de la Ley Nº 25.326."
        </em>
      </p>
      <p>
        <em>
          "La DIRECCIÓN NACIONAL DE PROTECCIÓN DE DATOS PERSONALES, órgano de control de
          la Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos que se
          interpongan con relación al incumplimiento de las normas sobre protección de
          datos personales."
        </em>
      </p>
    </LoginFooterBottom>
  </LoginFooterContainer>
);
